// import Firebase from 'firebase/app'
import { change, onSnapshot } from './helpers'

import {
  PlantHavestState,
  PlantHarvestContext,
  PlantHarvestAddInterface,
  PlantHarvestUpdateInterface,
  PlantHavestDeleteInterface,
} from '@/types/store'

import Harvest from '@/models/Harvest'

import { db } from '@/firebase'

import JFileContainer from '@/models/JFileContainer'
import { id } from '@/types/models'

export default {
  namespaced: true,
  state: (): PlantHavestState => ({
    data: [],
    unbinds: [],
  }),
  getters: {
    harvests: (state: PlantHavestState) => state.data,
    plantHarvests: (state: PlantHavestState) => (plantId: id) =>
      state.data.filter((h) => h.plantId === plantId),
    find: (state: PlantHavestState) => (harvestId: id) =>
      state.data.find((h) => h.id === harvestId),
  },
  mutations: {
    change,
    clear(state: PlantHavestState) {
      state.data = []
    },

    addUnbind(state: PlantHavestState, val: () => void) {
      state.unbinds.push(val)
    },
  },
  actions: {
    bind(context: PlantHarvestContext, [gardenId, plantId]: string[]) {
      const unsubscribe = db.onCollectionSnapshot(
        db
          .collection('gardens', gardenId, 'plants', plantId, 'harvests')
          .withConverter(Harvest.firestoreConverter(plantId)),
        (ref) => onSnapshot(context, ref)
      )

      // save unbind function to store
      context.commit('addUnbind', unsubscribe)
    },
    unbind(context: PlantHarvestContext) {
      // unsubscribe from firestore
      context.state.unbinds.forEach((fn) => fn())

      // clear from vuex store
      context.commit('clear')

      // TODO: unbind children based on collections() instead of root
    },
    add(
      { dispatch }: PlantHarvestContext,
      { gardenId, plantId, harvest, images }: PlantHarvestAddInterface
    ) {
      // let harvestDocRef: DocumentReference;
      harvest.isNew = true

      return new Promise((resolve, reject) => {
        return db
          .addDoc(
            db
              .collection('gardens', gardenId, 'plants', plantId, 'harvests')
              .withConverter(Harvest.firestoreConverter(plantId)),
            harvest
          )
          .then((harvestDocRef) => {
            return Promise.all(
              !images || images.length < 1
                ? []
                : images.map((file: JFileContainer) =>
                    dispatch(
                      'gardens/images/add',
                      {
                        gardenId,
                        file,
                        refs: [
                          `gardens/${gardenId}/plants/${plantId}/harvests/${harvestDocRef.id}`,
                        ],
                      },
                      { root: true }
                    )
                  )
            ).then(() => resolve(harvestDocRef))
          })
          .catch((err: Error) => reject(err))
      })
    },
    update(
      context: PlantHarvestContext,
      { gardenId, plantId, harvestId, updates }: PlantHarvestUpdateInterface
    ) {
      return db.updateDoc(
        db
          .doc('gardens', gardenId, 'plants', plantId, 'harvests', harvestId)
          .withConverter(Harvest.firestoreConverter(plantId)),
        updates
      )
    },
    async delete(
      context: PlantHarvestContext,
      { gardenId, plantId, harvestId }: PlantHavestDeleteInterface
    ) {
      const batch = db.writeBatch() // create firestore batch

      // ref to harvest in firestore
      const plantHarvestRef = db.doc(
        'gardens',
        gardenId,
        'plants',
        plantId,
        'harvests',
        harvestId
      )

      // find images
      const imagesQuerySnapshot = await db.getDocs(
        db.query(
          db.collection('gardens', gardenId, 'images'),
          db.where('refs', 'array-contains', plantHarvestRef)
        )
      )

      // loop all images
      imagesQuerySnapshot.forEach((doc) => {
        batch.delete(doc.ref) // add image doc to firestore batch
      })

      batch.delete(plantHarvestRef) // add harvest doc to firestore batch

      return batch.commit()
    },
  },
}
